export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const textMessage = node.data.textMessage || ''
  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  if (! textMessage) {
    $('#hover-node-card .card-body').html('')
  } else {
    let html = `<p><strong>Message:</strong> ${textMessage}</p>`
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }    
    $('#hover-node-card .card-body').html(html)
  }
}